module.exports = __webpack_public_path__ + "static/workshop-image-1b50ebfdad35dead30730379fd84b585.png";